import { css } from "@emotion/css";
import { space, themeTokens } from "@octopusdeploy/design-system-tokens";

export const containerStyle = css({
    display: "flex",
    gap: space[12],
    alignItems: "flex-start",
});

export const contentStyle = css({
    flex: 1,
});

export const titleStyle = css({
    fontWeight: 600,
    marginBottom: space[8],
    marginTop: 0,
});

export const iconStyle = css({
    color: themeTokens.color.icon.info,
});
